import axios from 'axios'

export default{
  namespaced: true,
  state: {
    correspondence: null,
    senderCategories: null
  },
  mutations: {
    updateCorrespondence (state, correspondence) {
      state.correspondence = correspondence
    },
    updateSenderCategories (state, senderCategories) {
      state.senderCategories = senderCategories
    }
  },
  actions: {
    async getCorrespondence ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/correspondence')
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/correspondence'
        var params = request != null ? request : {}
        return await axios.get(requestString, {params: params})
          .then(function (result) {
            commit('updateCorrespondence', result.data.correspondence)
            return result
          })
      } catch (e) {
        if (e && e.response) {
          console.log(
            `Error: the server responded with '${e.response.status}: ${
              e.response.statusText
            }'`
          )
        } else {
          console.log('Error loading correspondence', e)
        }
      }
    },
    async getCorrespondenceItem ({commit, state, rootState}, id) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/correspondence/${id}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async linkCorrespondence ({commit, state, rootState}, request) {
      try {
        return await axios.put(
          `/api/company/${rootState.userCurrentCompany.companyId}/correspondence/${request.id}/link`,
          { eventId: request.eventId }
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
        throw e
      }
    },
    async unlinkCorrespondence ({commit, state, rootState}, id) {
      try {
        return await axios.delete(
          `/api/company/${rootState.userCurrentCompany.companyId}/correspondence/${id}/link`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
        throw e
      }
    },
    async resolveCorrespondence ({commit, state, rootState}, request) {
      try {
        return await axios.put(
          `/api/company/${rootState.userCurrentCompany.companyId}/correspondence/${request.id}/resolve`,
          { resolved: request.resolved }
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
        throw e
      }
    },
    async setCorrespondenceCategory ({commit, state, rootState}, request) {
      try {
        return await axios.put(
          `/api/company/${rootState.userCurrentCompany.companyId}/correspondence/${request.id}/category`,
          { categoryId: request.categoryId }
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
        throw e
      }
    },
    async getSenderCategories ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/senderCategories')
      try {
        return await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/senderCategories'
        )
          .then(function (result) {
            commit('updateSenderCategories', result.data.senderCategories)
            return result
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    }
  }
}
